import * as React from "react";
import { Center, Spinner } from "react-ui";
import { useState } from "react";

import { ErrorLog } from "../../../Engine/Core/ErrorManager/Utils/Models";
import { NdsSverkaCheckWrapperContainer as NdsSverkaCheckWrapper } from "../Panel/NdsSverkaPanel/NdsSverkaCheckWrapperContainer";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";

import { Root } from "./EmbeddedLog.styles";
import { WidePanelLog } from "./WidePanelLog/WidePanelLog";

export interface EmbeddedLogProps {
    className?: string;
    onCheckErrors: () => void;
    errorLog: ErrorLog;
    modelChanged?: boolean;
    firstCheck?: boolean;
    hasNotLoadedAttachments: boolean;
    allowSend: boolean;
    isDisabledCloseAndSaveButton?: boolean;
    useExtendedErrorLog: boolean;
    canCheckByPopd?: boolean;
    readFromInner?: (path: string) => string;
    needShowNdsSverka?: boolean;
    getSverkaNdsPlusParams?: FormActionHandler;
}

export function EmbeddedLog(props: EmbeddedLogProps): JSX.Element {
    const [errHeaderOffset, setErrHeaderOffset] = useState<number>(0);

    function renderContent(): React.ReactElement {
        if (props.errorLog.isChecking) {
            return (
                <Center>
                    <Spinner caption="Проверяем..." type="normal" />
                </Center>
            );
        }

        return (
            <>
                {props.needShowNdsSverka && props.getSverkaNdsPlusParams && (
                    <NdsSverkaCheckWrapper
                        setErrHeaderOffset={setErrHeaderOffset}
                        getSverkaNdsPlusParams={props.getSverkaNdsPlusParams}
                    />
                )}
                <WidePanelLog
                    useExtendedErrorLog={props.useExtendedErrorLog}
                    hasNotLoadedAttachments={props.hasNotLoadedAttachments}
                    allowSend={props.allowSend}
                    onCheckErrors={props.onCheckErrors}
                    errorLog={props.errorLog}
                    canCheckByPopd={props.canCheckByPopd}
                    isDisabledCloseAndSaveButton={props.isDisabledCloseAndSaveButton}
                    modelChanged={props.modelChanged}
                    additionalHeaderOffset={errHeaderOffset}
                />
            </>
        );
    }

    return <Root className={props.className}>{renderContent()}</Root>;
}
